import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, GetManyParams, PageInfo } from '../../api.service';
import {
  Integration,
  RotateSecretParams,
  TestResult,
  UpdateIntegrationParams,
} from '../../../models/integration';
import { DeliveryStatus, WebhookDelivery } from '../../../models/webhook-delivery';
import { EventType } from '../../../models/integration';

export interface DeliveryListParams extends GetManyParams {
  status?: DeliveryStatus;
  eventType?: EventType | string;
}

@Injectable({
  providedIn: 'root',
})
export class IntegrationService {
  constructor(private apiService: ApiService) {}

  private baseUrl(companyUid: string): string {
    return `/companies/${companyUid}/integration`;
  }

  get(companyUid: string): Observable<Integration> {
    return this.apiService.get(this.baseUrl(companyUid), Integration);
  }

  update(companyUid: string, params: UpdateIntegrationParams): Observable<Integration> {
    return this.apiService.patch(this.baseUrl(companyUid), Integration, params);
  }

  rotateSecret(companyUid: string, params: RotateSecretParams = {}): Observable<Integration> {
    return this.apiService.post(`${this.baseUrl(companyUid)}/rotate_secret`, Integration, params);
  }

  test(companyUid: string): Observable<TestResult> {
    return this.apiService.post<any>(`${this.baseUrl(companyUid)}/test`);
  }

  getDeliveries(
    companyUid: string,
    params: DeliveryListParams,
  ): Observable<{ items: WebhookDelivery[]; paginationInfo: PageInfo }> {
    return this.apiService.getMany(`${this.baseUrl(companyUid)}/deliveries`, { ...params }, WebhookDelivery);
  }

  getDelivery(companyUid: string, eventId: string): Observable<WebhookDelivery> {
    return this.apiService.get(`${this.baseUrl(companyUid)}/deliveries/${eventId}`, WebhookDelivery);
  }

  retryDelivery(companyUid: string, eventId: string): Observable<WebhookDelivery> {
    return this.apiService.post(`${this.baseUrl(companyUid)}/deliveries/${eventId}/retry`, WebhookDelivery);
  }
}
